import { useIntl } from '@/intl'
import { useState } from 'react'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    addTimeWindowTooltip: translate({ id: 'order.form.bulk.timeWindows.addTimeWindowTooltip' }),

    addTimeWindowDisabledTooltip: translate({
      id: 'order.form.bulk.timeWindows.addTimeWindowDisabledTooltip',
    }),

    addTimeWindowExceptionTooltip: translate({
      id: 'ui.timeWindowsExceptions.addTimeWindowExceptionTooltip',
    }),

    addTimeWindowExceptionDisabledTooltip: translate({
      id: 'ui.timeWindowsExceptions.addTimeWindowExceptionDisabledTooltip',
    }),

    addTimeWindowExceptionLabel: translate({
      id: 'ui.timeWindowsExceptions.addTimeWindowExceptionLabel',
    }),

    timeWindowExceptionDateLabel: translate({
      id: 'ui.timeWindowsExceptions.timeWindowExceptionDateLabel',
    }),

    addTimeWindowsLabel: translate({
      id: 'ui.timeWindow.addTimeWindowsLabel',
    }),

    timeWindowsLabel: translate({
      id: 'ui.timeWindow.timeWindowsLabel',
    }),

    timeWindowExceptionRemoveTooltip: translate({
      id: 'global.remove',
    }),
  }))

  return api
}
